// Тема: светлая по умолчанию (как во всех сервисах Orbis). Тёмная — только если её явно выбрали кнопкой.
// Системная тёмная тема НЕ включает тёмную автоматически: на <html> всегда стоит явный data-theme,
// а он в orbis-tokens.css побеждает @media (prefers-color-scheme: dark).
import { useSyncExternalStore } from 'react'

export type ThemePref = 'light' | 'dark'
const KEY = 'oma-theme'

function readPref(): ThemePref {
  try {
    return window.localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

let pref: ThemePref = readPref()
const listeners = new Set<() => void>()

function apply(): void {
  document.documentElement.setAttribute('data-theme', pref)
}
apply()

export function setThemePref(p: ThemePref): void {
  pref = p
  try {
    window.localStorage.setItem(KEY, p)
  } catch {
    /* noop */
  }
  apply()
  for (const l of listeners) l()
}

export function toggleTheme(): void {
  setThemePref(pref === 'dark' ? 'light' : 'dark')
}

export function useThemePref(): ThemePref {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn)
      return () => {
        listeners.delete(fn)
      }
    },
    () => pref,
  )
}

/** Безопасная обёртка над localStorage для мелких предпочтений интерфейса. */
export function loadPref<T>(key: string, fallback: T): T {
  try {
    const v = window.localStorage.getItem(`oma:${key}`)
    return v === null ? fallback : (JSON.parse(v) as T)
  } catch {
    return fallback
  }
}

export function savePref(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(`oma:${key}`, JSON.stringify(value))
  } catch {
    /* noop */
  }
}
